import { ComponentSingleStyleConfig } from '@chakra-ui/theme/dist/types/theme.types';


export const Tag: ComponentSingleStyleConfig = {
  defaultProps: {
    colorScheme: 'gray',
  }
};
